export const hasOwn = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

export const generateQueryString = function (data) {
  //Do something with the input
  for (const item in data) {
    if (data[item] === null || data[item] === undefined || data[item] === "") {
      delete data[item];
    }
  }
  return Object.keys(data)
    .map((key) => key + "=" + data[key])
    .join("&");
};

//code for formatting numbers with comma
//end of the above code.
export const displayCount = function (number, decPlaces) {
  // 2 decimal places => 100, 3 => 1000, etc
  decPlaces = Math.pow(10, decPlaces);

  // Enumerate number abbreviations
  let abbrev = ["k", "m", "b", "t"];

  // Go through the array backwards, so we do the largest first
  for (let i = abbrev.length - 1; i >= 0; i--) {
    // Convert array index to "1000", "1000000", etc
    let size = Math.pow(10, (i + 1) * 3);

    // If the number is bigger or equal do the abbreviation
    if (size <= number) {
      // Here, we multiply by decPlaces, round, and then divide by decPlaces.
      // This gives us nice rounding to a particular decimal place.
      number = Math.round((number * decPlaces) / size) / decPlaces;

      // Handle special case where we round up to the next abbreviation
      if (number === 1000 && i < abbrev.length - 1) {
        number = 1;
        i++;
      }

      // Add the letter for the abbreviation
      number += abbrev[i];

      // We are done... stop
      break;
    }
  }
  return number;
};
// Below method is used for map the hs code filter array
// End of the above code
// below method is to map localisation filter array
//end of the above code
// Below Method is used for mapping the Filter Array
export const mapFiltersArray = function (data) {
  let filterArr = [];
  if (!!data && data.length > 0) {
    data.map((item) => {
      if (item.isChecked === true) {
        filterArr.push(item.key);
      }
    });
  }
  return filterArr;
};
// End of the above code
// Below Method is used for converting larger values to K,M,B format in view all analytics
export const getInternationalNumberSystem = function (labelValue) {
  return !!labelValue && labelValue !== "" && typeof labelValue === "number" ? (Math.abs(Number(labelValue)) >= 1.0e12 ? (Math.abs(Number(labelValue)) / 1.0e12).toFixed(2) + "T" : Math.abs(Number(labelValue)) >= 1.0e9 ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + "B" : Math.abs(Number(labelValue)) >= 1.0e6 ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + "M" : Math.abs(Number(labelValue)) >= 1.0e3 ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(2) + "K" : Math.abs(Number(labelValue))) : labelValue;
};
// End of above code
//Below code is to get object key by value
export const getObjectKeyByValue = (object, value) => {
  let result = "";
  if (value !== null && value !== undefined && object && typeof object === "object" && !Array.isArray(object)) {
    result = Object.keys(object).find((key) => object[key] === value);
  }
  return result ? result : "";
};

// Single source for the "Remaining Value Add Credit(s)" number.
// getUserCreditsByPlan now returns a server-computed `remaining` alongside
// credit_limit / credits_consumed, read straight from the UMS credit rows. Every
// surface must render that value: the old per-page `credit_limit -
// credits_consumed` subtraction ran over three different response shapes and
// over a Redis blob that Intel incremented locally, so Workspace disagreed with
// Tariffs and the HS Classifier for the whole session.
// The subtraction is kept only as a fallback for responses served before this
// change is deployed everywhere.
export const getRemainingValueAddCredits = (creditDetails) => {
  const valueAdd = creditDetails?.value_add_credits;
  if (!valueAdd) return null;
  if (typeof valueAdd.remaining === "number") return valueAdd.remaining;
  const { credit_limit: limit, credits_consumed: consumed } = valueAdd;
  if (typeof limit !== "number" || typeof consumed !== "number") return null;
  return Math.max(limit - consumed, 0);
};
